require('./src/styles/global.css')

// Registers country names for every served language; the header's coverage link needs them in the browser
require('./coverageCountries')

// First-touch cookie for signup attribution (docs/marketing/app-handoff-contract.md); written only with analytics consent
const { initAttribution } = require('./attribution')
// Plausible "Trial CTA Click" on links to pricing and signup (docs/marketing/tracking-contract.md)
const { initTrialCtaTracking } = require('./trialCta')
// Trial CTAs forward the page's UTMs and ref at click time; internal pricing links go through Gatsby's navigate
const { navigate } = require('gatsby')

exports.onInitialClientRender = () => {
  initAttribution(window)
  initTrialCtaTracking(window, { navigate })

  let getQueryVariable = (variable) => {
    let query = window.location.search.substring(1)
    let vars = query.split('&')
    for (let i = 0; i < vars.length; i += 1) {
      let pair = vars[i].split('=')
      if (pair[0] === variable) {
        return pair[1]
      }
    }
    return false
  }

  // https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
  function setCookie(name, value, days) {
    let expires = ''
    if (days) {
      let date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie =
      name + '=' + (value || '') + expires + '; domain=myphoner.com; path=/'
  }

  let initCookies = () => {
    let ref = getQueryVariable('ref')

    // Not consent-gated: it lets a referred customer claim their referral discount (owner decision 2026-10-07)
    if (ref) {
      setCookie('affiliate', ref, 30)
    }
    // The legacy attribution cookies were replaced by myphoner_ft (B2b, 2026-10-08); expire any left from earlier visits
    setCookie('myphoner_source', '', -1)
    setCookie('myphoner_referrer', '', -1)
  }

  initCookies()
}
